import React from 'react';
import { Alert, AlertTitle } from '@mui/material';

const ErrorAlert = ({ error, onClose }) => {
  if (!error) return null;

  const getErrorMessage = (error) => {
    if (typeof error === 'string') return error;
    if (error.message) return error.message;
    if (error.detail) return error.detail;
    return 'An unexpected error occurred';
  };

  return (
    <Alert 
      severity="error" 
      onClose={onClose}
      sx={{ mb: 2 }}
    >
      <AlertTitle>Error</AlertTitle>
      {getErrorMessage(error)}
    </Alert>
  );
};

export default ErrorAlert;